import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// IMPORTANT: This Firebase project is SHARED between fixit (client) and fixit2 (service provider)
// Both apps use the SAME Firebase project and database to enable interconnected functionality
// TODO: Replace with your actual Firebase config (use the SAME config in both apps)
const firebaseConfig = {
    apiKey: "AIzaSyBleAnPBGzpc4yH9fChB2Nmh-b1A-sxT8Y",
    authDomain: "skillhive-6600.firebaseapp.com",
    projectId: "skillhive-6600",
    storageBucket: "skillhive-6600.firebasestorage.app",
    messagingSenderId: "535174388656",
    appId: "1:535174388656:web:8b3f3a8ff0c6ed2c311475",
    measurementId: "G-4S06TG08PV"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

export default app;
